import React, { useState, lazy, Suspense } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import Nav from "./Components/nav";
import LoadingScreen from "./Components/Loading screen";
import useGetOrders from "./hooks/useGetOrders";
import useGetComProducts from "./hooks/useGetComProducts";
import useGetProducts from "./hooks/useGetProducts";
import useGetUser from "./hooks/useGetUser";
import useGetRealtimeUser from "./hooks/useGetRealtimeUser";
import useGetUtils from "./hooks/useGetUtils";
import useGetAuthState from "./hooks/useGetAuthState";
import useGetMappedData from "./hooks/useGetMappedData";
import getCartImage from "./utils/cart images function";
import useFormtemplates from "./hooks/useFormTemplates";
import useSearchSystem from "./hooks/useSearchSystem";
import Footer from "./Components/footer";
import About from "./Pages/about";
import Credits from "./Pages/credits";
import useGetInterests from "./hooks/useGetInterests";
import useGetStoreProducts from "./hooks/useGetStoreProducts";
import useGetComments from "./hooks/useGetComments";
import useGetReplies from "./hooks/useGetReplies";
import useContactSeller from "./hooks/useContactSeller";
import useGetChatRoomsAsClient from "./hooks/useGetChatRooms";
import useLogin from "./hooks/useLogin";

//                           TODO:
// DONE | delete cart or productCart form signupform and firestore!!!!
// DONE | make the phone number throw an error if it detects letters!!!!
// DONE | make the phone number field validation accept any type of phone number!!!
// DONE | signupForm and loginForm should be moved to thier own file and should be only used to
//        fix validation for forms
// add a meaning after every discount from firestore app1-15-euros or app1-15-% and improve the function
//        to make it work with both -> if % value/100
// DONE | add more information for the products added to the cart and improve getCartImage to filter by
//        pName + pBrand or id or category
// fix the buttons not working if you click the text instead of the button in checkout or change all with mantine buttons
// DONE | pass the id of the product when adding it to the cart so you can use it in IndividualOrder
//        to navigate to that product's store page
// uninstall jspdf
// change import for html2pdf
// DONE | add to the cart the price with the discount not the full price
// DONE | change the price from dollars to euros
// DONE |   set the taxes and other stuff when you add the product to cart
// give the possibility to make the adress in the checkout only one line
// add a loading animations when sumbiting doc in sell preoducts using task.on(state_changed)
// throw an error if images don't load into storage in sell2
// DONE | get all orders in the collection and filter just the ones you need for display
// DONE | rethink the system for the com products so you contact the person that uploaded the product
//        so you don't have to add them to cart
// DONE | implement a chat system like on olx or something
// DONE | add something to let people know when they update their profile info like a modal
// DONE | implement lazy loading
// implement lazy loading for cart and favorites
// DONE | add a checkbox to each category from all categories and if the box is checked
//        add it to a categories array in firestore in the user doc and display that
//        on the landing page in a row of up to 5 items, mke it so you can check up to 4 boxes
// DONE | ratings should have a separate div below the info one in the products page
// DONE | delete the thumbnail property when you add new products
// DONE | add uncategorized to the categories array
// fix de rerender problem when clicking insede an input (sell, edit, cards, adresses, etc..)

export default function App() {
  const Login = lazy(() => import("./Pages/Login"));
  const Signup = lazy(() => import("./Pages/Signup"));
  const MyAccount = lazy(() => import("./Pages/My account"));
  const CheckoutPage = lazy(() => import("./Pages/checkout page"));
  const IndividualOrder = lazy(() => import("./Pages/individual order"));
  const SellingPage = lazy(() => import("./Pages/selling  page"));
  const ComProductsPage = lazy(() => import("./Pages/community products"));
  const IndividualComPage = lazy(() => import("./Pages/individual com page"));
  const Individual = lazy(() => import("./Pages/individual page"));
  const LandingPage = lazy(() => import("./Pages/Landing page"));
  const Tac = lazy(() => import("./Pages/Terms and conditions"));
  const SearchPage = lazy(() => import("./Pages/search page"));
  const ContactSellerPage = lazy(() => import("./Pages/contact seller page"));
  const EditProductPage = lazy(() => import("./Pages/EditProduct"))

  const { productsArr, categoriesArr } = useGetProducts();
  const { userData, userId } = useGetUser();
  const { realTimeData } = useGetRealtimeUser(userId);
  const { utils } = useGetUtils();
  const { isLoggedIn } = useGetAuthState();
  const [openOptions, setOpenOptions] = useState({
    categories: false,
    onlyProducts: false,
    editMode: false,
    adressModal: false,
    cardModal: false,
    billModal: false,
    cardFace: true,
    cardFaceChange: false,
    filtersPannel: false,
    productDeletSelector: false,
    moreOptionsMenu: false,
    cardDeleteSelector: false,
    adressDeleteSelector: false,
    sellSuccessModal: false,
    productEditMode: false,
    chatRequestModal: false,
    chatDeleteModal: false,
  });
  let quantity = 1;
  const [productsToDelete, setProductsToDelete] = useState([]);
  const { loginErr } = useLogin(realTimeData);
  const { myOrders } = useGetOrders(userId);
  const { comProductsArr } = useGetComProducts();
  const mixedProductsArr = comProductsArr?.concat(productsArr.products);
  const {
    editProfile,
    orderModel,
    sellingModel,
    loginForm,
    signupForm,
    uploadCardModel,
    commentModel,
    replyModel,
    uploadAdressModel
  } = useFormtemplates(loginErr);
  const { interestsObj } = useGetInterests(productsArr.products, userData);
  const { chatRoomsArr } = useGetChatRoomsAsClient(userId);
  const { contactSeller, chatRoomObject } = useContactSeller(
    realTimeData,
    userId,
    chatRoomsArr
  );
  const {
    mappedCart,
    mappedSoldByMe,
    mappedFavorites,
    mappedComFavorites,
    comProducts,
    choosenInterests,
    storeProducts
  } = useGetMappedData(
    realTimeData,
    comProductsArr,
    productsArr,
    userId,
    interestsObj,
    quantity,
    openOptions,
    setProductsToDelete,
    productsToDelete,
    chatRoomObject,
    setOpenOptions,
  );
  const { toSearch } = useParams();
  const { search, changeTerm, filteredProducts, searchTerm, setSearchTerm } =
    useSearchSystem(productsArr.products, toSearch);
  const { storeProductsArr } = useGetStoreProducts();
  const { commentsArr } = useGetComments();
  const { repliesArr } = useGetReplies();
  return (
    <div
      style={{
        background: "#f1f1f1",
      }}
    >
      <Nav
        mappedCart={mappedCart}
        realTimeData={realTimeData}
        mappedFavorites={mappedFavorites}
        mappedComFavorites={mappedComFavorites}
        productsArr={productsArr}
        search={search}
        changeTerm={changeTerm}
        categoriesArr={categoriesArr}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        signupForm={signupForm}
        userId={userId}
        userData={userData}
      />
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          <Route
            path="/auth/login"
            element={
              <Login realTimeData={realTimeData} loginForm={loginForm} />
            }
          />
          <Route
            path="/auth/signup"
            element={<Signup signupForm={signupForm} />}
          />
          <Route path="/auth/terms-and-conditions" element={<Tac />} />
          <Route
            exact
            path="/"
            element={
              <LandingPage
                productsObj={productsArr}
                choosenInterests={choosenInterests}
                storeProducts={storeProducts}
              />
            }
          />
          <Route
            path="/my-account"
            element={
              <MyAccount
                userId={userId}
                editProfile={editProfile}
                openOptions={openOptions}
                setOpenOptions={setOpenOptions}
                userData={userData}
                isLoggedIn={isLoggedIn}
                orderModel={orderModel}
                getCartImage={getCartImage}
                comProductsArr={comProductsArr}
                mappedSoldByMe={mappedSoldByMe}
                productsArr={productsArr}
                myOrders={myOrders}
                uploadCardModel={uploadCardModel}
                productsToDelete={productsToDelete}
                setProductsToDelete={setProductsToDelete}
                chatRoomsArr={chatRoomsArr}
                uploadAdressModel={uploadAdressModel}
              />
            }
          />
          <Route
            path="/products/:prodT"
            element={
              <Individual
                productsObj={productsArr}
                quantity={quantity}
                userId={userId}
                realTimeData={realTimeData}
                orderModel={orderModel}
                commentModel={commentModel}
                replyModel={replyModel}
                storeProductsArr={storeProductsArr}
                commentsArr={commentsArr}
                repliesArr={repliesArr}
              />
            }
          />
          <Route
            path="/my-account/my-orders/:orderNumber"
            element={
              <IndividualOrder
                getCartImage={getCartImage}
                productsArr={productsArr}
                myOrders={myOrders}
              />
            }
          />
          <Route
            path="/checkout-page"
            element={
              <CheckoutPage
                mappedCart={mappedCart}
                userData={userData}
                orderModel={orderModel}
                userId={userId}
                utils={utils}
                setOpenOptions={setOpenOptions}
                realTimeData={realTimeData}
              />
            }
          />
          <Route
            path="/my-account/sell-products"
            element={
              <SellingPage
                sellingModel={sellingModel}
                realTimeData={realTimeData}
                mappedSoldByMe={mappedSoldByMe}
                categories={categoriesArr}
                userId={userId}
                comProductsArr={comProductsArr}
                setOpenOptions={setOpenOptions}
              />
            }
          />
          <Route
            path="/community-sellings"
            element={<ComProductsPage comProducts={comProducts} />}
          />
          <Route
            path="/community-sellings/:prodT"
            element={
              <IndividualComPage
                userId={userId}
                realTimeData={realTimeData}
                comProductsArr={comProductsArr}
                contactSeller={contactSeller}
                setOpenOptions={setOpenOptions}
                openOptions={openOptions}
                chatRoomObject={chatRoomObject}
              />
            }
          />
          <Route to="info/about" element={<About />} />
          <Route to="info/credits" element={<Credits />} />
          <Route
            path="/search/:toSearch"
            element={
              <SearchPage
                productsArr={productsArr}
                filteredProducts={filteredProducts}
                userId={userId}
                realTimeData={realTimeData}
                quantity={quantity}
                openOptions={openOptions}
                setOpenOptions={setOpenOptions}
                mixedProductsArr={mixedProductsArr}
                comProductsArr={comProductsArr}
              />
            }
          />
          <Route path="contact/:contactId" element={<ContactSellerPage />} />
          <Route
            path="/my-account/edit-products/:requestedProdId"
            element={
              <EditProductPage
                sellingModel={sellingModel}
                realTimeData={realTimeData}
                mappedSoldByMe={mappedSoldByMe}
                categories={categoriesArr}
                userId={userId}
                comProductsArr={comProductsArr}
                setOpenOptions={setOpenOptions}
              />
            }
          />
        </Routes>
      </Suspense>
      <Footer />
    </div>
  );
}
